export default "__VITE_ASSET__wWpf8TvH__"